import styled from "styled-components";


export const StyledCategoriesContainer = styled.div`
  width: 50%;
  padding-right: 16px;
`;
